<div class="event-mini-preview" *ngIf="eventPreview">
  <div class="event-mini-preview__image-wrapper">
    <brt-image [image]="eventPreview.image"></brt-image>
  </div>
  <div class="event-mini-preview__body">
    <div class="event-mini-preview__header">
      <div class="event-mini-preview__title">
        {{ eventPreview.name }}
      </div>
    </div>
    <div class="event-mini-preview__tags-wrapper" *ngIf="eventPreview.appointments.length > 0">
      <div class="event-mini-preview__tag" *ngIf="eventPreview.appointments.length === 1">
        <span class="icon-calendar"></span> {{ eventPreview.appointments[0].startDate }}<ng-container *ngIf="eventPreview.appointments[0].endDate.length && eventPreview.appointments[0].endDate !== eventPreview.appointments[0].startDate"> – {{ eventPreview.appointments[0].endDate }}</ng-container>
      </div>
      <ng-container *ngIf="eventPreview.appointments.length > 1">
        <div class="event-mini-preview__tag" *ngFor="let eventDate of eventPreview.appointments.slice(0, 5)">
          <span class="icon-calendar"></span> {{ eventDate.startDate }}<ng-container *ngIf="eventDate.endDate.length && eventDate.endDate !== eventDate.startDate"> – {{ eventDate.endDate }}</ng-container>
        </div>

        <div class="event-mini-preview__tag" *ngIf="eventPreview.appointments.length > 5" brtTooltip [text]="getAppointmentDatesText(eventPreview.appointments)">
          <span class="icon-calendar"></span> +{{ eventPreview.appointments.length - 5 }}
        </div>
      </ng-container>
    </div>

    <a [routerLink]="'/angebote/' + eventPreview.id" class="animline animline--black event-mini-preview__link" [target]="'_blank'" *ngIf="eventPreview">Mehr Informationen</a>
  </div>
</div>
